
import {createSlice} from '@reduxjs/toolkit'
import { fetchmainworkorderstatus } from '../../action/master/mainworkorderstatusAction'

interface mainworkorderstatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: mainworkorderstatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const mainworkorderstatusSlice = createSlice({
  name: 'mainworkorderstatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchmainworkorderstatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchmainworkorderstatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchmainworkorderstatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default mainworkorderstatusSlice.reducer
